export const state = {
  userDetails: null,
  userProfileMenuItems: [],
  selectedCustomer: null,
};

export const mutations = {
  SET_USER_DETAILS(state, payload) {
    state.userDetails = payload;
  },
  SET_USER_PROFILE_MENU_ITEMS(state, payload) {
    state.userProfileMenuItems = payload;
  },
  SET_SELECTED_CUSTOMER(state, payload) {
    state.selectedCustomer = payload;
  },
};

export const actions = {
  setUserDetails({ commit }, payload) {
    commit('SET_USER_DETAILS', payload)
  },
  setUserProfileMenuItems({ commit }, payload) {
    commit('SET_USER_PROFILE_MENU_ITEMS', payload)
  },
  setSelectedCustomer({ commit }, payload) {
    commit('SET_SELECTED_CUSTOMER', payload)
  },
}